module.exports = __webpack_public_path__ + "assets/img/people.665094ec.svg";